/* bm_peakExplorer_rectangle.js – Rechteck-Layer */
(function () {
  window.BM = window.BM || {};
  if (window.BM.__peakExplorerRectangleLoaded) return;
  window.BM.__peakExplorerRectangleLoaded = true;

  const KM_PER_LATITUDE_DEGREE = 110.574;
  const KM_PER_LONGITUDE_DEGREE_AT_EQUATOR = 111.320;
  const MAX_MERCATOR_LATITUDE = 85.051129;

  function createRectangleLayer(map, ids, options = {}) {
    const COLOR = options.lineColor || '#253545';
    const FILL_OPACITY = options.fillOpacity ?? 0.12;
    const BEFORE = options.beforeId || null;
    const ON_UPDATE = typeof options.onUpdate === 'function' ? options.onUpdate : null;

    const SOURCE_ID = ids.source;
    const FILL_ID = ids.fill;
    const LINE_ID = ids.line;

    const selectionData = { type: 'FeatureCollection', features: [] };

    function ensure() {
      if (!map.getSource(SOURCE_ID)) {
        map.addSource(SOURCE_ID, { type: 'geojson', data: selectionData });
      }
      if (!map.getLayer(FILL_ID)) {
        map.addLayer({
          id: FILL_ID,
          type: 'fill',
          source: SOURCE_ID,
          paint: { 'fill-color': COLOR, 'fill-opacity': FILL_OPACITY }
        }, BEFORE || undefined);
      }
      if (!map.getLayer(LINE_ID)) {
        map.addLayer({
          id: LINE_ID,
          type: 'line',
          source: SOURCE_ID,
          paint: { 'line-color': COLOR, 'line-width': 2.5, 'line-opacity': 1 }
        }, BEFORE || undefined);
      }
    }

    function kmToDegreesX(km, latDeg) {
      const lat = (latDeg * Math.PI) / 180;
      const kmPerDegX = KM_PER_LONGITUDE_DEGREE_AT_EQUATOR * Math.cos(lat);
      return km / kmPerDegX;
    }

    function kmToDegreesY(km) {
      return km / KM_PER_LATITUDE_DEGREE;
    }

    function rotatePoint(xKm, yKm, angleRad) {
      if (!angleRad) return [xKm, yKm];
      const cos = Math.cos(angleRad);
      const sin = Math.sin(angleRad);
      return [
        xKm * cos - yKm * sin,
        xKm * sin + yKm * cos
      ];
    }

    function rectPolygon(center, dimensions) {
      const [lng, lat] = center;
      const widthKm = Number(dimensions?.widthKm);
      const heightKm = Number(dimensions?.heightKm);
      const rotationDeg = Number(dimensions?.rotationDeg || 0);

      const halfWidth = widthKm / 2;
      const halfHeight = heightKm / 2;
      const angleRad = -rotationDeg * (Math.PI / 180);

      const cornersKm = [
        [-halfWidth, -halfHeight],
        [halfWidth, -halfHeight],
        [halfWidth, halfHeight],
        [-halfWidth, halfHeight]
      ];

      const coords = cornersKm.map(([xKm, yKm]) => {
        const [rotX, rotY] = rotatePoint(xKm, yKm, angleRad);
        return [
          lng + kmToDegreesX(rotX, lat),
          lat + kmToDegreesY(rotY)
        ];
      });

      coords.push(coords[0]);

      return {
        type: 'Feature',
        geometry: { type: 'Polygon', coordinates: [coords] },
        properties: {}
      };
    }

    function update(center, dimensions, fit = false) {
      const lng = Number(center?.[0]);
      const lat = Number(center?.[1]);
      const widthKm = Number(dimensions?.widthKm);
      const heightKm = Number(dimensions?.heightKm);
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;
      if (Math.abs(lat) > MAX_MERCATOR_LATITUDE) return;
      if (!Number.isFinite(widthKm) || widthKm <= 0) return;
      if (!Number.isFinite(heightKm) || heightKm <= 0) return;

      ensure();
      const selectionFeature = rectPolygon([lng, lat], dimensions);
      selectionData.features = [selectionFeature];
      const source = map.getSource(SOURCE_ID);
      source?.setData?.(selectionData);

      if (ON_UPDATE) {
        const polygon = selectionFeature.geometry.coordinates[0].map((coordinate) => [
          Number(coordinate[0]),
          Number(coordinate[1])
        ]);
        const longitudes = polygon.map((coordinate) => coordinate[0]);
        const latitudes = polygon.map((coordinate) => coordinate[1]);

        ON_UPDATE({
          center: [lng, lat],
          bounds: [
            Math.min(...longitudes),
            Math.min(...latitudes),
            Math.max(...longitudes),
            Math.max(...latitudes)
          ],
          widthKm,
          heightKm,
          rotationDeg: Number(dimensions?.rotationDeg || 0),
          polygon
        });
      }

      if (fit) {
        const poly = selectionData.features[0];
        const coords = poly.geometry.coordinates[0];
        const bounds = new mapboxgl.LngLatBounds(coords[0], coords[0]);
        for (const coord of coords) bounds.extend(coord);
        const reduceMotion = window.BM.util?.prefersReducedMotion?.() || false;
        map.fitBounds(bounds, { padding: 40, duration: reduceMotion ? 0 : 350 });
      }
    }

    ensure();
    return { update };
  }

  window.BM.createRectangleLayer = createRectangleLayer;
})();
